var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleCircleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2051 3.91714C41.1621 0.246836 35.8493 -1.30623 31.7067 1.28673C27.8078 3.72699 26.0634 8.50531 22.5392 11.3933C18.8444 14.4213 14.7767 14.5801 10.3033 14.0397C6.44726 13.5739 2.05871 13.6472 0.534841 18.1045C-1.11746 22.9381 1.3206 28.6263 4.27152 32.3525C7.18093 36.0264 11.2385 38.487 15.7102 39.4506C24.6224 41.3711 35.1242 38.1594 41.474 31.336C48.0381 24.2822 50.8389 11.9182 44.2051 3.91714Z",
    fill: "#F4E4FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCircleBg);
export default __webpack_public_path__ + "static/media/PurpleCircleBG.dfe74428ea0dbd9ca11a8d8552baf806.svg";
export { ForwardRef as ReactComponent };